<div class="db-ai-builder-create-page-builder__content">
  <div class="title">
    <i class="db-icon db-icon-ds-arrow-small" (click)="onBack.emit()" *ngIf="!hideBackButton"></i>
    <h2>AI Builder</h2>
  </div>
  <p class="mb8"><b>Insert the URL to create your new page</b></p>
  <p class="mb22">The new page will inherit the header, footer and styles (colors and fonts) from your existing website.</p>


  <form [formGroup]="builderForm" (ngSubmit)="recreate()">
    <div class="ds-input-wrap mb9">
      <input type="text" class="ds-input"
             [ngClass]="{'error': builderForm.get('title').invalid && builderForm.get('title').touched}"
             placeholder="Insert the page title" formControlName="title">
      <span *ngIf="builderForm.get('title').invalid && builderForm.get('title').touched"
            class="ds-input-error-msg" [innerHTML]="'This field is required.'"></span>
    </div>


    <div class="ds-input-wrap recreate-url mb9">
      <input type="text" class="ds-input"
             [ngClass]="{'error': builderForm.get('url').invalid && builderForm.get('url').touched}"
             placeholder="Insert URL to recreate" formControlName="url">
      <i *ngIf="!urlChecking && builderForm.get('url').valid" class="db-icon db-icon-ds-checkmark-bg checkmark"></i>
      <span *ngIf="urlChecking" class="ds-spinner-circle checking"></span>
      <span *ngIf="builderForm.get('url').invalid && builderForm.get('url').touched"
            class="ds-input-error-msg"
            [innerHTML]="builderForm.get('url')?.errors['required'] ? 'This field is required.':
              builderForm.get('url')?.errors?.pattern ? 'Please enter http:// or https://' :
              builderForm.get('url')?.errors?.invalidUrl ? builderForm.get('url')?.errors?.invalidUrl : ''"></span>
    </div>

<!--    <div class="ds-input-wrap enable-theme mb15" *ngIf="!websiteTenWebTheme || (websiteTenWebTheme && !websiteTenWebTheme.active)">
      <input class="ds-checkbox" formControlName="check" [checked]="builderForm.get('check')?.value" type="checkbox" id="check">
      <label for="check"><span class="in-builder mt15" [innerHTML]="'text_enableTenWebTheme' | dbText"></span></label>
    </div>-->
    <div class="db-button-wrap">
      <button class="ds-btn-blue" [ngClass]="{'ds-btn-disabled': builderForm.invalid || urlChecking}" type="submit">
        <i class="db-icon db-icon-ds-diamond mr8" *ngIf="demoUser"></i>
        <span>Recreate</span>
      </button>
      <div class="db-demo-tooltip" *ngIf="demoUser && (builderForm.invalid || urlChecking)">Unlock this feature with 10Web pro plans. <a (click)="showUpgradePopup.emit('AI')"><span>Try now for free.</span></a></div>
    </div>
  </form>


</div>
<div class="ai-builder-create-page__image" *ngIf="!isMobile">
</div>
